import { matchPath } from 'react-router';
import { createSelector } from 'reselect';

import { PATH } from 'constants/RoutesConstants';
import { getCurrentLocation } from 'selectors/router';

const GROUP_PATHS = [PATH.GROUP_TAGS_DASHBOARD, PATH.GROUP_TAGS_DETAILS];
const DEALER_PATHS = [PATH.DEALER_TAGS_DASHBOARD, PATH.DEALER_TAGS_DETAILS];
const ALL_PATHS = [...GROUP_PATHS, ...DEALER_PATHS];

const getURLParams = createSelector(getCurrentLocation, pathname => {
  const currentPath = ALL_PATHS.find(path => matchPath(path.path, pathname));
  return currentPath ? matchPath(currentPath.path, pathname)?.params ?? null : null;
});

export const getTagModeFromRoute = createSelector(getURLParams, params => params?.mode);

export const getTagIdFromRoute = createSelector(getURLParams, params => params?.tagId);

export const isTagsDealerContext = createSelector(getCurrentLocation, pathname =>
  DEALER_PATHS.some(path => matchPath(path.path, pathname)));
